module.exports = __webpack_public_path__ + "img/sortImg1-1-3.c2de4fe9.png";